export type EngineSource =
    | {
          type: "LocalEngineSources";
          path: string;
      }
    | {
          type: "PublishedEngine";
          version: string;
      };

export function getEngineSourceKey(source: EngineSource): string {
    return source.type === "LocalEngineSources" ? source.path : source.version;
}
